import certificatesData from "./certificates.json";

// Export certificates data directly (no require() needed since image paths are already full URLs)
export default certificatesData.certificates;
